import Content from './content'
import Styles from './style.module.scss'

export default function ProductSolution() {
  return (
    <div className={Styles.productSolution}>
      <h2>Product & Solution</h2>
      <Content />
    </div>
  )
}
